import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { flatMap, isEmpty, some } from "lodash-es";

import { CUSTOMER_OFFER_ACTION_TYPE } from "./customer-offer.action";
import { CustomerOffer, CustomerOfferState, FulfillmentStep } from "./customer-offer.model";

const INITIAL_STATE: CustomerOfferState = {
	isEnabled: false,
	customerOffers: [],
	hasDepositOffers: false,
	hasLoginOffers: false,
};

export function customerOfferStateReducer(state = INITIAL_STATE, action: ActionWithPayload): CustomerOfferState {
	switch (action.type) {
		case CUSTOMER_OFFER_ACTION_TYPE.setEnabled: {
			return updateState(state, {
				isEnabled: action.payload,
			});
		}
		// todo: consolidate rewards and offers including reward processors OBGB-3409
		case CUSTOMER_OFFER_ACTION_TYPE.getSuccess: {
			const customerOffers: CustomerOffer[] = action.payload;
			return updateState(state, {
				customerOffers,
				hasDepositOffers: hasFulfillmentOfferByStep(customerOffers, FulfillmentStep.deposit),
				hasLoginOffers: hasFulfillmentOfferByStep(customerOffers, FulfillmentStep.login),
			});
		}
		case CUSTOMER_OFFER_ACTION_TYPE.getVisitorOffersSuccess: {
			const visitorOffers: CustomerOffer[] = action.payload;
			return updateState(state, {
				visitorOffers,
			});
		}
		case CUSTOMER_OFFER_ACTION_TYPE.getFail:
		case CUSTOMER_OFFER_ACTION_TYPE.getVisitorOffersFail: {
			return updateState(state, {
				...INITIAL_STATE,
				isEnabled: state.isEnabled,
			});
		}
		case CUSTOMER_OFFER_ACTION_TYPE.clearCustomerOffers: {
			return updateState(state, {
				customerOffers: INITIAL_STATE.customerOffers,
			});
		}
		case CUSTOMER_OFFER_ACTION_TYPE.clearVisitorOffers: {
			return updateState(state, {
				visitorOffers: INITIAL_STATE.visitorOffers,
			});
		}
		default:
			return state;
	}
}

function hasFulfillmentOfferByStep(customerOffers: CustomerOffer[], fulfillmentStep: FulfillmentStep): boolean {
	const fullFillmentSteps = customerOffers.map((x) => x.nextFulfillmentSteps);

	if (isEmpty(fullFillmentSteps)) {
		return false;
	}

	return some(
		flatMap(fullFillmentSteps, (x) => x!.next),
		{ type: fulfillmentStep }
	);
}
